// the organization which have animation for activation of the bot the name of the organization is to be specified and the duration of the gif provided

let organization = [
  {
    orgName: "gala",
    isChatBotAnimation: true,
    gifTime: 11500,
    orgColor: "#3d92fc",
    softSkillFormId: "qxBZdrc2",
    techSkillFormId: "naWTlhB2",
    eventFormId: "r4fljGXc",
    alexName: "alvox",
  },
  {
    orgName: "datarmony",
    isChatBotAnimation: false,
    orgColor: "#3d92fc",
    softSkillFormId: "zGCjiJT4",
    techSkillFormId: "zSzMbnMm",
    eventFormId: "wNegDqv1",
  },
  {
    orgName: "sitel-learning",
    isChatBotAnimation: false,
    orgColor: "#E71B44",
    softSkillFormId: "v9lBB06Z",
    techSkillFormId: "LEXY46Yy",
    eventFormId: "rKw3FXDi",
  },
  //eu-business-school
  {
    orgName: "euruni",
    isChatBotAnimation: false,
    orgColor: "#00BE96",
    softSkillFormId: "ChxB4kCG",
    techSkillFormId: "pq7hjovQ",
    eventFormId: "xv4GXPCs",
    alexName: "alfred",
  },
  //sandbox accounts for testing on local
  {
    orgName: "sitel-learning-sandbox",
    isChatBotAnimation: false,
    orgColor: "#E71B44",
    softSkillFormId: "zGCjiJT42",
    techSkillFormId: "zSzMbnMm",
    eventFormId: "rKw3FXDi",
  },
];
export default organization;
